<template>
  <v-card
    :color="color"
    :id="cardId"
    class="pl-2 d-flex elevation-4"
    dark
    height="100%"
  >
    <v-row no-gutters align="center" class="row pa-2">
      <v-col cols="2">
        <v-icon v-if="icon !== ''" size="40">
          {{ icon }}
        </v-icon>
        <icon
          v-if="awesomeicon !== ''"
          class="ml-1 mt-2"
          scale="2.2"
          :name="awesomeicon"
        />
      </v-col>
      <v-col cols="9" class="align-start text-left ml-2">
        <v-card-title class="pa-0">
          <span
            class="font-weight-light ml-2 text-truncate"
            :style="responsiveFontSizeStyleTitle"
            >{{ title }}</span
          >
        </v-card-title>
        <v-card-text
          :style="responsiveFontSizeStyleValue"
          class="font-weight-light ml-3 pa-0"
        >
          {{ displayedString }}
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'stats-card',

  props: {
    cardId: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    awesomeicon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: undefined
    },
    value: {
      type: String | Number,
      default: undefined
    },
    unit: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      cardWidth: Math.round(window.innerWidth / 7)
    }
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize)
    this.updateCardWidth()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize)
  },

  methods: {
    onWindowResize(event) {
      this.updateCardWidth()
    },

    // If element is null (before first render), cardwidth needs to be
    // assumed from browser window size. To divide it by 7 is a good
    // approximation (determined empirically)
    updateCardWidth() {
      Vue.nextTick(() => {
        // use next tick to have the card rendered before measuring the width
        let element = document.getElementById(this.cardId)
        if (!element) {
          this.cardWidth = Math.round(window.innerWidth / 7)
        } else {
          this.cardWidth = element.clientWidth
        }
      })
    },

    // in fontSize, 1.5 corresponds to the approximate width to height ratio of characters
    fontSizeOneLine(nbOfCharacters, nbOfPixels) {
      let fontSize = Math.round((nbOfPixels / nbOfCharacters) * 1.5)
      fontSize = fontSize > 24 ? 24 : fontSize
      fontSize = fontSize < 13 ? 13 : fontSize
      return fontSize
    }
  },

  computed: {
    displayedString() {
      if ((this.value === undefined || this.value === '') && this.unit !== '') {
        return 'undefined'
      }
      return this.value + ' ' + this.unit
    },

    // in nbOfPixels, 58 corresponds to 50 (icon size) + 2 * 4 (margins)
    responsiveFontSizeStyleValue() {
      let iconSize = 50
      let margins = 2 * 4
      let nbOfPixels = this.cardWidth - iconSize - margins
      let nbCharactersEffective = this.displayedString.length
      let nbOfCharacters = 20 // use a constant to have all cards using the same font
      if (nbCharactersEffective < 15) {
        nbOfCharacters = 12
      }
      let fontSize = this.fontSizeOneLine(nbOfCharacters, nbOfPixels)
      return 'font-size: ' + String(fontSize) + 'px'
    },

    responsiveFontSizeStyleTitle() {
      let nbOfPixels = this.cardWidth - 58
      let nbOfCharacters = 22 // use a constant to have all cards using the same font String(this.value).length + this.unit.length + 1
      let nbCharactersEffective = String(this.title).length
      if (nbCharactersEffective > 22) {
        nbOfCharacters = nbCharactersEffective
      }
      let fontSize = this.fontSizeOneLine(nbOfCharacters, nbOfPixels)
      return 'font-size: ' + String(fontSize) + 'px'
    }
  }
}
</script>

<style scoped></style>
